import React from 'react'
import { PageHeader } from '@superhi/design'

import ROUTE from './route'
import Intro from './components/Intro'

import Main from 'src/components/Main'
import Page from 'src/components/Page'
import ContactSection from 'src/components/sections/Contact'
import SEO from 'src/components/SEO'
import { PageConfig } from 'src/routing/types'

const Contact: PageConfig<unknown> = () => (
  <Page>
    <SEO title="Contact us" />

    <Main>
      <PageHeader title="Contact us" backgroundVersion="BLUE_03" />

      <Intro />

      <ContactSection subtitle="We're pretty quick to reply to anything you wanna ask!" />
    </Main>
  </Page>
)

Contact.route = ROUTE

export default Contact
